<template>
  <v-card :flat="true">
    <alert-card
        v-if="alert.visible === true"
        v-model:visible="alert.visible"
        :type="alert.type"
        :title="alert.title"
        :text="alert.text"
        :closable="false"
        class="px-0"
    />
    <payment-details
        :balances="accountStatistics.balances"
        :requests-finished="accountStatistics.requestsFinished"
        :loading="loadingStatistic"
    />
    <v-divider/>
    <payment-list
        :items="paymentList"
        :skeleton-amount="limit"
        :loading="loadingPaymentList"
        class="mt-4"
    />
    <v-pagination
        v-model="this.page"
        :length="this.pageAmount"
    />
  </v-card>
</template>

<script>
import PaymentDetails from "@/components/Payment/PaymentDetails.vue";
import PaymentList from "@/components/Payment/PaymentList.vue";
import {inject} from "vue";
import {auth} from "@/common/auth";
import {router} from "@/router";
import {api} from "@/common/api";
import {PaymentType} from "@/common/enum/payment_type";
import {dates} from "@/common/dates";
import AlertCard from "@/components/AlertCard.vue";
import {messages} from "@/common/enum/messages";
import {numbers} from "@/common/numbers";

export default {
  name: "PaymentsView",
  components: {AlertCard, PaymentList, PaymentDetails},
  data() {
    return {
      page: 1,
      total: 1,
      limit: 10,
      accountStatistics: {},
      paymentList: [],
      paymentsRequestState: null,
      loadingStatistic: false,
      loadingPaymentList: false,
      alert: {
        initiator: null,
        visible: false,
        type: 'error',
        title: 'Error',
        text: ''
      }
    }
  },
  computed: {
    pageAmount() {
      return Math.ceil(this.total / this.limit)
    }
  },
  setup() {
    return {
      switchAuthorizationState: inject('authorization').switchState
    }
  },
  mounted() {
    this.loadAccountStatistics()
    this.loadPaymentList()
  },
  methods: {
    loadPaymentList() {
      const token = auth.getToken()
      if (token == null) {
        this.switchAuthorizationState()
        router.push({name: 'sign-in', state: {redirectTo: 'home'}})
        return
      }

      if (this.paymentsRequestState && !this.paymentsRequestState.signal.aborted) {
        this.paymentsRequestState.abort()
      }

      this.paymentsRequestState = new AbortController()
      this.loadingPaymentList = true
      api.getPayments(token, {
        page: this.page,
        limit: this.limit
      }, this.paymentsRequestState.signal, this.setPayments)
    },
    setPayments(response) {
      this.loadingPaymentList = false
      if (response?.data?.status === 'error') {
        this.alert.initiator = 'payments'
        this.alert.visible = true
        this.alert.type = 'error'
        this.alert.title = 'Error'
        this.alert.text = response.data?.message?.length === 0 ? messages.en.payments_view.payments_loading_error : response.data.message
        return
      }

      this.resetAlert('payments')
      const payments = response.data.payments
      this.total = response.data.total
      this.paymentList = payments.map(payment => {
        return {
          id: payment.id,
          type: PaymentType[payment.type],
          amount: numbers.formatMoney(payment.value, payment.currency),
          description: payment.description,
          date: dates.mapToDate(payment.created_at),
        }
      });
    },
    loadAccountStatistics() {
      const token = auth.getToken()
      if (token == null) {
        this.switchAuthorizationState()
        router.push({name: 'sign-in', state: {redirectTo: 'home'}})
        return
      }

      this.loadingStatistic = true
      api.getAccountStatistics(token, this.setAccountStatistics)
    },
    setAccountStatistics(response) {
      if (response?.data?.status === 'error') {
        this.alert.initiator = 'statistic'
        this.alert.visible = true
        this.alert.type = 'error'
        this.alert.title = 'Error'
        this.alert.text = response.data?.message?.length === 0 ? messages.en.payments_view.statistic_loading_error : response.data.message
        return
      }

      this.resetAlert('statistic')
      this.loadingStatistic = false
      const statistics = response.data

      this.accountStatistics = {
        balances: statistics.balances.map(balance => {
          return {
            balance: numbers.formatMoney(balance.balance_amount, balance.currency),
            hold: numbers.formatMoney(balance.hold_amount, balance.currency),
            spent: numbers.formatMoney(balance.debit_amount, balance.currency),
          }
        }),
        requestsFinished: statistics.finished_requests_amount
      }
    },
    resetAlert(initiator) {
      if (this.alert.initiator === initiator) {
        this.alert.visible = false
      }
    }
  }
}
</script>

<style scoped>

</style>